<template>
  <div>
    <div class="text-xl font-black py-2">11. Feedback & Improvements</div>

    <!-- Sub section-->
    <div class="text-lg font-black py-2">Feedback on the Guild</div>
    <div>
      <div v-for="(question, index) in form.questions[page][sectionStart]" :key="index">
        <review-question-component v-model="form.questions[page][sectionStart][index]" container-class="flex justify-between w-full" :showMandatory="showMandatory"></review-question-component>
      </div>
    </div>

  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'

export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value
    }
  }
}
</script>
